<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="false"
            :activityId="78"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="促销橱窗设置"></jd-title>
          <div class="mt20">
            <el-form-item required label="专享价配置:" v-if="!venderType">
              <jd-button
                type="blue"
                @click="selectExclusivePrice"
                :disabled="activityData.isStart"
              >
                选择专享价（{{ exclusivePriceList.length }}/1）
              </jd-button>
              <span class="ml8 label-color"
                >活动的折扣来源于专享价配置，选择专享价后用户根据专享权益规则选购，可获取专享下单价</span
              >
              <div class="invite-box mt16" v-if="exclusivePriceList.length > 0">
                <div>
                  <div class="label-style">专享价名称：</div>
                  <span>{{
                    exclusivePriceList[0].name || exclusivePriceList[0].title
                  }}</span>
                </div>
                <div>
                  <div class="label-style">专享价活动时间：</div>
                  <span>{{ exclusivePriceList[0].startTime }}</span>
                  <span>至</span>
                  <span>{{ exclusivePriceList[0].endTime }}</span>
                </div>
                <div v-if="maxItemNum > 0 && minItemNum > 0">
                  <div class="label-style">商品限购：</div>
                  <span
                    >每笔订单中每个商品最少购买{{
                      minItemNum || 0
                    }}件，最多购买{{ maxItemNum || 0 }}件才能享受专享价</span
                  >
                </div>
                <div>
                  <div class="label-style">订单限购：</div>
                  <span>每个账号限购1次</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item required label="令牌配置:" v-else>
              <jd-button
                type="blue"
                @click="selectToken"
                :disabled="activityData.isStart"
              >
                选择令牌（{{ exclusivePriceList.length }}/1）
              </jd-button>
              <span class="ml8 label-color"
                >活动的折扣来源于令牌优惠配置，选择令牌后用户根据令牌权益规则选购，可获取专享下单价</span
              >
              <div class="invite-box mt16" v-if="exclusivePriceList.length > 0">
                <div>
                  <div class="label-style">令牌名称：</div>
                  <span>{{
                    exclusivePriceList[0].name || exclusivePriceList[0].title
                  }}</span>
                </div>
                <div>
                  <div class="label-style">令牌有效时间：</div>
                  <span>{{ exclusivePriceList[0].startTime }}</span>
                  <span>至</span>
                  <span>{{ exclusivePriceList[0].endTime }}</span>
                </div>
                <div>
                  <span class="label-style">令牌ID：</span>
                  <span>{{ tokenId }}</span>
                </div>
                <div>
                  <div class="label-style">秘钥：</div>
                  <span>{{ secretKey }}</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item required label="优惠名额:">
              <!-- 仅可输入大于1的整数数值 -->
              <el-input
                v-model="quotas"
                placeholder="请输入"
                class="w125"
                @input="quotas = handleInput($event)"
                @blur="handleBlur($event)"
              />
              <span class="ml8 label-color"
                >限制优惠打包价的参与用户名额，不建议大于下方商品最大的优惠名额</span
              >
            </el-form-item>
            <el-form-item required label="选择商品:">
              <combinationProduct
                :limitNum="20"
                :isDisabled="activityData.isStart"
                :tableInfo="tableInfo"
                :prizeList.sync="windowSkuList"
              >
                <template #tips>
                  <span class="ml8 label-color"
                    >请填写当前选择的专享价中配置的商品。
                    <jd-button type="blueText" @click="handlePromoPriceBlur"
                      >促销价配置参考</jd-button
                    >
                  </span>
                </template>
              </combinationProduct>
            </el-form-item>
            <el-form-item label="优惠券配置:">
              <el-switch
                v-model="ruleDTO.couponEnabled"
                :disabled="activityData.isStart"
                @change="changeCouponConfig"
              >
              </el-switch>
              <el-form-item
                required
                label="选择优惠券:"
                v-if="ruleDTO.couponEnabled"
              >
                <jd-button
                  type="blue"
                  @click="addCoupon"
                  :disabled="activityData.isStart"
                  >选择优惠券（{{ couponList.length }}/10）</jd-button
                >
                <span class="ml8 label-color"
                  >建议配置“推荐商品”可用优惠券，以便于促进消费者下单</span
                >
                <jd-table
                  class="mt16"
                  :tableInfo="couponTableInfo"
                  :tableData="couponList"
                  v-if="couponList.length > 0"
                >
                  <!-- 优惠券金额 -->
                  <template #priceSlot="{ row }">
                    <div>{{ row.price ? row.price + "元" : "" }}</div>
                  </template>
                  <template #conditionSlot="{ row }">
                    {{
                      row.quota
                        ? "满" + row.quota + "可用"
                        : row.quota == 0 && row.price
                        ? "满0可用"
                        : ""
                    }}
                  </template>
                  <!-- 发放数量 -->
                  <template #totalAmount="{ row }">
                    <el-input
                      v-model="row.totalAmount"
                      placeholder="请输入"
                      class="w125"
                      @input="
                        row.totalAmount = getNumberData(1, $event, 0, 1, 999999)
                      "
                      :disabled="activityData.isStart"
                    />
                  </template>
                  <template #operation="{ row, rowIndex }">
                    <div>
                      <jd-button
                        type="blueText"
                        @click="selectCoupon(row,rowIndex)"
                        :disabled="activityData.isStart"
                        >选择优惠券</jd-button
                      >
                      <jd-button
                        type="blueText"
                        :disabled="activityData.isStart"
                        @click="removeCoupon(rowIndex)"
                      >
                        删除
                      </jd-button>
                      <jd-button
                        type="blueText"
                        v-if="activityData.isStart"
                        @click="itemAddNum('couponList', rowIndex)"
                        >增加奖品数量</jd-button
                      >
                    </div>
                  </template>
                </jd-table>
              </el-form-item>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="推荐组合设置"></jd-title>
          <div class="mt20">
            <el-form-item label="推荐组合展示:">
              <el-switch
                v-model="ruleDTO.recommendComboEnabled"
                @change="changeCombination"
                :disabled="activityData.isStart"
              >
              </el-switch>
              <el-form-item
                label="推荐组合:"
                label-width="auto"
                v-if="ruleDTO.recommendComboEnabled"
              >
                <jd-button type="blue" @click="addCombination"
                  >新增组合（{{ combos.length }}/10）</jd-button
                >
                <div v-if="combos.length > 0">
                  <div
                    class="invite-box mt16 flexc"
                    v-for="(item, index) in combos"
                    :key="item.id"
                  >
                    <div class="move-btn">
                      <jd-button
                        type="blueText"
                        v-if="index != 0"
                        @click="moveUp(index)"
                        >上移</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="index != combos.length - 1"
                        @click="moveDown(index)"
                        >下移</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="index != 0"
                        @click="removeCombination(index)"
                      >
                        删除</jd-button
                      >
                    </div>
                    <div class="label-style">
                      组合{{ indexType(index + 1) }}：
                    </div>
                    <div class="goods-content">
                      <combinationProduct
                        :limitNum="5"
                        :tableInfo="comBineTableInfo"
                        :prizeList.sync="item.skuList"
                      >
                        <template #tips>
                          <span class="ml8 label-color"
                            >建议配置上方已配置商品</span
                          >
                        </template>
                        <template #price-tips>
                          <div class="mb8" v-if="item.skuList.length > 0">
                            <span>组合原价：{{ item.originalPrice }}元</span>
                            <span class="ml12"
                              >打包价：{{ item.packagePrice }}元</span
                            >
                          </div>
                        </template>
                      </combinationProduct>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1670"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/fixed-pack-design.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <fixedPricePackDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :productList="windowSkuList"
                :couponList="couponList"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="主按钮背景图：" label-width="130px">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 1)"
                        :on-success="(res) => handleUploadUI(res, 1)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.url2">
                          <img
                            :src="customerPaperwork.url2"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.url2 = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：388*102px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="主按钮文案颜色：" label-width="130px">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.btnColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.btnColor = currrentRgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="商品背景图:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 2)"
                    :on-success="(res) => handleUploadUI(res, 2)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url3">
                      <img :src="customerPaperwork.url3" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueLine"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url3 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：180*200px</span>
                </div>
              </el-form-item>
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item
                    label="推荐组合按钮背景图："
                    label-width="160px"
                  >
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 3)"
                        :on-success="(res) => handleUploadUI(res, 3)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.url4">
                          <img
                            :src="customerPaperwork.url4"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.url4 = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：172*102px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="推荐组合文案颜色：" label-width="160px">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.recommendColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.recommendColor = currrentRgb3"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="优惠券区域背景图:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 4)"
                    :on-success="(res) => handleUploadUI(res, 4)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url5">
                      <img :src="customerPaperwork.url5" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueLine"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url5 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：70*218px</span>
                </div>
              </el-form-item>
              <el-form-item label="优惠券背景图:">
                <div class="buttonGroup">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="(file) => beforeUploadUI(file, 5)"
                    :on-success="(res) => handleUploadUI(res, 5)"
                  >
                    <div class="bg-wrap" v-if="customerPaperwork.url6">
                      <img :src="customerPaperwork.url6" class="bg-wrap-img" />
                    </div>
                    <jd-button
                      v-else
                      type="blueLine"
                      label="自定义上传"
                      :disabled="backgroundOpacity"
                    ></jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    @click="customerPaperwork.url6 = ''"
                    class="ml16"
                    :disabled="backgroundOpacity"
                    >重置</jd-button
                  >
                  <span class="size-tip">尺寸建议：212*102px</span>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 专享价弹框 -->
    <selectSpecialDialog
      v-if="isShowExclusivePrice"
      v-model="isShowExclusivePrice"
      :exclusivePriceId="specialId"
      @confirm="confirmExclusive"
    ></selectSpecialDialog>
    <!-- 令牌弹框 -->
    <selectTokenDialog
      v-if="isShowToken"
      v-model="isShowToken"
      :tokenId="specialId"
      @confirm="confirmToken"
    ></selectTokenDialog>
    <!-- 选择优惠券 -->
    <selectPrize v-model="isShowCoupon" :echoDate="echoDate" @closePrize="closePrize"></selectPrize>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import {
  saveOrUpdatePackageFixedPrice,
  getPackageFixedPriceDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import selectPrize from "./select_prize.vue";
import combinationProduct from "./components/combinationProduct.vue";
import selectSpecialDialog from "./components/selectSpecialDialog.vue";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import fixedPricePackDialog from "./components/newActPreviews/fixed-price-pack-dialog.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import { getExclusivePricePlanDetail } from "@/api/jhk/integralCenter/prizeCenter.js";
import { promoTokenDetail } from "@/api/integralCenter/tokenSummary.js";
import {useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    selectSpecialDialog,
    selectTokenDialog,
    selectPrize,
    combinationProduct,
    fixedPricePackDialog,
    addPrizeNum,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tokenId: "",
      secretKey: "",
      toAddItem: {},
      toAddBelong: "",
      toAddIndex: 0,
      isShowAddNum: false,
      maxItemNum: 0,
      minItemNum: 0,
      isAllowEdit: false, //是否允许编辑
      specialId: "",
      combos: [
        {
          id: new Date().getTime(),
          skuList: [],
        },
      ],
      indexCoupon: 0,
      itemArr: [],
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      echoDate: {},
      isShowCoupon: false,
      couponList: [],
      isLimit: true,
      isShowGoods: false,
      tableInfo: [
        {
          label: "商品信息",
          slot: "productSlot",
          minWidth: 180,
        },
        {
          label: "京东价",
          prop: "jdPrice",
          minWidth: 120,
        },
        {
          label: "促销价",
          slot: "promotionPrice",
          minWidth: 120,
        },
        {
          label: "单商品优惠库存",
          slot: "totalAmount",
          minWidth: 120,
        },
        {
          label: "操作",
          slot: "operation",
          minWidth: 120,
        },
      ],
      comBineTableInfo: [
        {
          label: "商品信息",
          slot: "productSlot",
          minWidth: 180,
        },
        {
          label: "京东价",
          prop: "jdPrice",
          minWidth: 120,
        },
        {
          label: "促销价",
          slot: "promotionPrice",
          minWidth: 120,
        },
        // {
        //   label: "单商品优惠库存",
        //   slot: "totalAmount",
        //   minWidth: 120,
        // },
        {
          label: "操作",
          slot: "operation",
          minWidth: 120,
        },
      ],
      couponTableInfo: [
        {
          label: "优惠券名称",
          prop: "title",
          minWidth: 120,
        },
        {
          label: "面额",
          slot: "priceSlot",
          minWidth: 120,
        },
        {
          label: "使用条件",
          slot: "conditionSlot",
          minWidth: 120,
        },
        {
          label: "发放数量",
          slot: "totalAmount",
          minWidth: 120,
        },
        {
          label: "操作",
          slot: "operation",
          minWidth: 120,
        },
      ],
      windowSkuList: [],
      isShowToken: false,
      isShowExclusivePrice: false,
      exclusivePriceList: [],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E6%89%93%E5%8C%85%E4%B8%80%E5%8F%A3%E4%BB%B7.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      customerPaperwork: {
        title: "打包一口价",
        desc: "超级橱窗，组合优惠更划算",
        titleColor: "",
        url2: "", //主按钮背景图
        url3: "", //商品背景图
        url4: "", //推荐组合按钮背景图
        url5: "", //优惠券区域背景图
        url6: "", //优惠券背景图
        btnColor: "", //主按钮文案颜色
        recommendColor: "", //推荐组合按钮文案颜色
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        assetsId: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      quotas: "", //优惠名额
      sharePic: "https://cdn-image.yucrm.cn/hd/images/fixed-pack-share.png",
      ruleDTO: {
        recommendComboEnabled: false,
        couponEnabled: false, // 优惠券配置
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/fixed-pack-share.png",
        openCardStartTime: "",
        openCardEndTime: "", //庆典时间
        // 活动设置字段
        activityType: 1, //活动类型
        customActivityName: "", //庆典名称
        customActivityTime: "", //庆典时间
        showMemoryBook: true, //是否展示回忆录
        memoryBookTimeType: 1, //回忆录统计时间
        giftType: 2, //赠送许愿币
        unifiedCoins: "", //赠送许愿币数
        celebrationType: 2, //领奖有效期
        celebrationBeforeDays: "", //领奖有效期前天数
        celebrationAfterDays: "", //领奖有效期后天数
        gameTime: 60,
        gameScorePer: 10,
        // foreScoreTotal: 0,
        giveTimes: "",
        gameCntLimit: "",
        // 奖品字段
        prizeGetType: 0,
        oneDayMaxRewardNumber: "",
        totalMaxRewardNumber: "",
        prizeLimit: "",
        scoreLimit: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    indexType() {
      return (type) => {
        const typeObj = {
          1: "一",
          2: "二",
          3: "三",
          4: "四",
          5: "五",
          6: "六",
          7: "七",
          8: "八",
          9: "九",
          10: "十",
        };
        return typeObj[type] || type;
      };
    },
  },
  watch: {
    combos: {
      deep: true,
      immediate: true,
      handler(val) {
        this.calculateCombinationPrices(val);
      },
    },
  },
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.buriedPoint(1, "打包一口价", "互动管理", "互动活动");
  },

  methods: {
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    handleInput(val) {
      return val.replace(/[^\d]/g, "");
    },
    handleBlur(val) {
      const newVal = val.target.value;
      if (+newVal <= 1) {
        this.$message.warning("优惠名额不能小于等于1");
        this.quotas = "";
      }
    },
    handlePromoPriceBlur() {
      window.open("https://jdpricepresale.shop.jd.com/price-query?");
    },
    // 计算组合价格
    calculateCombinationPrices(list) {
      list.forEach((item) => {
        item.originalPrice = item.skuList.reduce((sum, good) => {
          return sum + (Number(good.jdPrice) || 0);
        }, 0);

        item.packagePrice = item.skuList.reduce((sum, good) => {
          return sum + (Number(good.promoPrice) || 0);
        }, 0);
      });
      this.$forceUpdate();
    },
    // 上移
    moveUp(index) {
      this.combos[index] = this.combos.splice(
        index - 1,
        1,
        this.combos[index]
      )[0];
    },
    // 下移
    moveDown(index) {
      this.combos[index] = this.combos.splice(
        index + 1,
        1,
        this.combos[index]
      )[0];
    },
    // 删除
    removeCombination(index) {
      this.combos.splice(index, 1);
    },
    addCombination() {
      if (this.combos.length >= 10) {
        return this.$message.warning("最多只能添加10个组合");
      }
      this.combos.push({
        id: new Date().getTime(),
        skuList: [],
      });
    },
    changeCombination(val) {
      this.combos = [
        {
          id: new Date().getTime(),
          skuList: [],
        },
      ];
    },
    changeCouponConfig(val) {
      this.couponList = [];
    },
    addCoupon() {
      if (this.couponList.length >= 10) {
        return this.$message.warning("最多只能选择10个优惠券");
      }
      this.couponList.push({
        title: "",
        prizeType: null,
        price: null,
        totalAmount: null,
        quota: "",
        assetsId: "",
        groupNums: "",
        couponType: "",
      });
    },
    closePrize(val, params) {
      if (val) {
        if (this.venderType && val.couponType == 1) {
          return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        }
        let isflay = false;
        this.couponList.forEach((item) => {
          if (item.assetsId === params.couponId) {
            isflay = true;
          }
        });
        // if (isflay) {
        //   return this.$message.warning("你已选用该优惠券，请重新选择");
        // }
        this.couponList[this.indexCoupon].quota = params.quota;
        this.couponList[this.indexCoupon].prizeType = 1;
        this.couponList[this.indexCoupon].assetsId = params.couponId;
        this.couponList[this.indexCoupon].couponType = params.couponType;
        this.couponList[this.indexCoupon].price =
          params.discount || params.singleAmount;
        this.couponList[this.indexCoupon].title =
          params.name.length >= 12 ? params.name.substring(0, 12) : params.name;
          this.couponList[this.indexCoupon].prizeGoShop = params.prizeGoShop;
      }
      this.isShowCoupon = false;
    },
    selectCoupon(row,index) {
      this.indexCoupon = index;
      this.isShowCoupon = true;
      this.echoDate = row;
    },
    removeCoupon(index) {
      this.couponList.splice(index, 1);
    },
    // 判断时间函数
    checkTimeRange(start, end, type) {
      const obj = {
        1: "专享价活动",
        2: "令牌有效",
      };
      // 活动开始时间不能小于专享价开始时间且活动结束时间不能大于专享价结束时间
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();
      const activityStartTime = new Date(this.activityStartTime).getTime();
      const activityEndTime = new Date(this.activityEndTime).getTime();
      if (startTime > activityStartTime) {
        this.$message({
          message: `活动开始时间不能早于${obj[type]}开始时间`,
          type: "warning",
        });
        return true;
      }
      if (endTime < activityEndTime) {
        this.$message({
          message: `活动结束时间不能晚于${obj[type]}结束时间`,
          type: "warning",
        });
        return true;
      }
      return false;
    },
    selectToken() {
      if (!this.activityStartTime && !this.activityEndTime) {
        this.$message({
          message: "请先设置活动开始时间和结束时间",
          type: "warning",
        });
        return;
      }
      this.isShowToken = true;
    },
    confirmToken(e) {
      if (this.checkTimeRange(e.startTime, e.endTime, 2)) {
        return;
      }

      this.specialId = e.id;
      this.tokenId = e.tokenId;
      this.secretKey = e.secretKey;
      this.exclusivePriceList = [
        {
          beginTime: e.startTime,
          endTime: e.endTime,
          price: 0,
          title: e.name,
          logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
          assetsId: e.id,
          prizeType: 13,
          singleAmount: 1,
        },
      ];
      this.isShowToken = false;
    },
    confirmExclusive(val) {
      if (this.checkTimeRange(val.startTime, val.endTime, 1)) {
        return;
      }
      this.maxItemNum = val.maxItemNum;
      this.minItemNum = val.minItemNum;
      this.specialId = val.id;
      this.exclusivePriceList = [
        {
          beginTime: val.startTime,
          endTime: val.endTime,
          price: val.minPayPrice,
          title: val.name,
          logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
          assetsId: val.id,
          prizeType: 12,
          singleAmount: 1,
        },
      ];
      this.isShowExclusivePrice = false;
    },
    selectExclusivePrice() {
      if (!this.activityStartTime && !this.activityEndTime) {
        this.$message({
          message: "请先设置活动开始时间和结束时间",
          type: "warning",
        });
        return;
      }
      this.isShowExclusivePrice = true;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      // let sizeype = {
      //   1: {
      //     width: 388,
      //     height: 102,
      //   },
      //   2: {
      //     width: 180,
      //     height: 200,
      //   },
      //   3: {
      //     width: 172,
      //     height: 102,
      //   },
      //   4: {
      //     width: 710,
      //     height: 218,
      //   },
      //   5: {
      //     width: 212,
      //     height: 102,
      //   },
      // };
      // const status = await this.imgchecked(
      //   file,
      //   sizeype[type].width,
      //   sizeype[type].height
      // );
      // if (!status) {
      //   return false;
      // }
      return false;
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("主按钮背景图上传成功");
        } else if (type == 2) {
          this.customerPaperwork.url3 = res.data;
          this.$message.success("商品背景图上传成功");
        } else if (type == 3) {
          this.customerPaperwork.url4 = res.data;
          this.$message.success("推荐组合按钮背景图上传成功");
        } else if (type == 4) {
          this.customerPaperwork.url5 = res.data;
          this.$message.success("优惠券区域背景图上传成功");
        } else if (type == 5) {
          this.customerPaperwork.url6 = res.data;
          this.$message.success("优惠券背景图上传成功");
        }
      }
    },
    initCustomizeData(row) {
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.btnColor = row.rgb2;
      this.customerPaperwork.recommendColor = row.rgb3;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      this.lvLoading = true;
      if (this.activityData.isStart) {
        this.lvLoading = false;
      }
      querymemberLevel()
        .then((res) => {
          this.lvLoading = false;
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {});
    },
    //生成规则
    generateRule() {
      let text1 = `在活动时间范围内可选择最少1件商品，最多${this.windowSkuList.length}件商品，进行打包加购`,
        text2 =
          "每人最多可获取一次打包活动价，多次购买仅第一次可使用打包促销价；",
        text3 = "优惠券：",
        secondText = "【活动参与规则】",
        thirdText = "【优惠券领取】",
        fourthText = "【注意事项】";
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      if (this.ruleDTO.couponEnabled && this.couponList.length > 0) {
        text3 +=
          this.couponList
            .map(
              (item) =>
                `${
                  item.quota
                    ? "满" + item.quota + "可用"
                    : item.quota == 0 && row.price
                    ? "满0可用"
                    : ""
                }优惠券*${item.totalAmount}`
            )
            .join("、") +
          "\n" +
          "每人仅可领取一张且仅可领取一次；";
      }
      let Arr1 = [
        firstText,
        [secondText, text2],
        [thirdText, text3],
        [fourthText, precautions],
      ];
      let newText = "";
      if (!this.ruleDTO.couponEnabled && this.couponList.length == 0) {
        // 删除优惠券领取
        Arr1.splice(2, 1);
      }
      const objIndex = {
        0: "\n一、",
        1: "\n二、",
        2: "\n三、",
        3: "\n四、",
      };
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = `${newText}${
                index == 2 && this.ruleDTO.couponEnabled ? "" : newNum
              }${index == 2 && this.ruleDTO.couponEnabled ? "" : "."}${row}\n`;
            } else {
              if (index != 0) {
                newText = newText + objIndex[index] + row + "\n";
              } else {
                newText = newText + row + "\n";
              }
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }
      if (this.exclusivePriceList.length == 0) {
        return this.$message.warning(
          `请完善${this.venderType ? "令牌" : "专享"}配置`
        );
      }
      if (!this.quotas) {
        return this.$message.warning("请输入优惠名额");
      }
      if (this.windowSkuList.length == 0) {
        return this.$message.warning("请选择商品");
      }

      const flag = this.windowSkuList.some(
        (item) => !item.promoPrice || !item.totalAmount
      );

      if (flag) {
        return this.$message.warning("请完善商品信息");
      }
      if (this.ruleDTO.couponEnabled) {
        if (this.couponList.length == 0) {
          return this.$message.warning("请添加优惠券");
        }
        if (this.couponList.some((item) => !item.title || !item.totalAmount)) {
          return this.$message.warning("请完善优惠券信息");
        }
      }
      if (this.ruleDTO.recommendComboEnabled) {
        if (this.combos.length == 0) {
          return this.$message.warning("请添加推荐组合");
        }
        const hasCombin = this.combos.some((item) => item.skuList.length == 0);
        if (hasCombin) {
          return this.$message.warning("请添加推荐组合商品");
        }
        let isTrue = this.combos.some((item) => {
          return item.skuList.some((row) => !row.promoPrice);
        });
        if (isTrue) {
          return this.$message.warning("请完善推荐组合商品信息");
        }
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if (this.placementPosition.length == 0) {
        this.$message.warning("请选择活动投放位置！");
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        combos: this.ruleDTO.recommendComboEnabled
          ? this.combos.map((item, index) => {
              return {
                ...item,
                skuList: item.skuList.map((row, it) => {
                  return {
                    ...row,
                    sort: it + 1,
                  };
                }),
                sort: index + 1,
              };
            })
          : [],
      };
      let obj = {
        ...this.ruleForm,
        subType: 78,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
        windowSkuList: this.windowSkuList.map((item, index) => {
          return {
            ...item,
            sort: index + 1,
            remanentAmount: this.activityData.isCopy
              ? null
              : item.remanentAmount
              ? item.remanentAmount
              : null,
            id: this.activityData.isCopy ? null : item.id ? item.id : null,
          };
        }),
      };
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      // 奖品处理
      let prizeListCommon = [];
      if (this.exclusivePriceList.length > 0) {
        prizeListCommon = this.exclusivePriceList.map((item) => {
          return {
            ...item,
            totalAmount: +this.quotas,
          };
        });
      }

      if (this.ruleDTO.couponEnabled && this.couponList.length > 0) {
        prizeListCommon.push(...this.couponList);
      }
      obj.pointActivityPrizeDTOList = prizeListCommon;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeListCommon
              .filter((item) => item.id)
              .map((item) => {
                return {
                  ...item,
                  prizeId: item.id,
                };
              }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: obj.isValidBlackList,
            windowSkuList: obj.windowSkuList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveOrUpdatePackageFixedPrice(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getPackageFixedPriceDetail(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              isValidBlackList,
              windowSkuList,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              combos,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.isValidBlackList = isValidBlackList;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity || 0;
            this.placementPosition = placementPosition
              ? placementPosition.split(",")
              : ["SHOP"];
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;

            this.templateJson = JSON.parse(res.data.templateJson);
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              // 专享价回显
              const type = this.venderType ? 13 : 12;
              if (
                pointActivityPrizeDTOList &&
                pointActivityPrizeDTOList.length > 0
              ) {
                const prizeList = pointActivityPrizeDTOList.filter(
                  (item) => item.prizeType == type
                );
                this.exclusivePriceList = prizeList.map((item) => {
                  return {
                    ...item,
                    name: item.title,
                    startTime: item.beginTime,
                    endTime: item.endTime,
                  };
                });
                // 优惠券回显
                if (
                  pointActivityPrizeDTOList &&
                  pointActivityPrizeDTOList.length > 0
                ) {
                  this.couponList = pointActivityPrizeDTOList.filter(
                    (item) => item.prizeType == 1
                  );
                }
                // 商品回显
                this.windowSkuList = windowSkuList || [];
                // 组合商品回显
                this.combos = combos || [];
                if (!this.venderType) {
                  getExclusivePricePlanDetail(
                    this.exclusivePriceList[0].assetsId
                  ).then((res) => {
                    if (res.code == 1) {
                      this.maxItemNum = res.data.maxItemNum;
                      this.minItemNum = res.data.minItemNum;
                    }
                  });
                } else {
                  promoTokenDetail({
                    id: this.exclusivePriceList[0].assetsId,
                  }).then((res) => {
                    if (res.code == 1) {
                      this.tokenId = res.data.tokenId;
                      this.secretKey = res.data.secretKey;
                    }
                  });
                }
              }
              if (this.exclusivePriceList.length > 0) {
                this.quotas = this.exclusivePriceList[0].totalAmount;
                // 专享价id回显
                this.specialId = this.venderType
                  ? this.exclusivePriceList[0].id
                  : this.exclusivePriceList[0].assetsId;
              }
              this.ruleForm.ruleDescription = ruleDescription;
            }
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
            this.templateId = templateId;
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-givetips {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .upload-box {
    width: 500px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .bg-wrap {
    width: 80px;
    // overflow: hidden;
    &-img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .invite-box {
    position: relative;
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
    .label-style {
      display: inline-block;
      text-align: right;
      flex-shrink: 0;
    }
    .goods-content {
      width: 95%;
    }
    .move-btn {
      position: absolute;
      top: 16px;
      right: 16px;
    }
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }
  .mr8 {
    margin-right: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }
  .w400 {
    width: 400px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
  .size-tip {
    color: #aaaaaa;
    margin-left: 8px;
  }
  .btn_boxs {
    background-color: rgb(248, 249, 252);
    padding: 16px;
    border-radius: 4px;
    width: 500px;
  }
  .limit {
    display: flex;
    align-items: center;
    color: #333333;
  }
  .label-color {
    color: #333333;
  }

  .copywriting {
    display: flex;
    flex-direction: column;
  }

  .goods-box {
    display: flex;
    align-items: center;
    padding: 10px;
    img {
      width: 60px;
      height: 60px;
    }
  }
}
.flex-c {
  display: flex;
  flex-direction: column;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
